import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';

export default () => (
  <StaticQuery
    query={graphql`
      query {
        image: file(relativePath: { eq: "service-hero.jpg" }) {
          childImageSharp {
            fluid(maxHeight: 700, quality: 95) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <Img fluid={{ ...data.image.childImageSharp.fluid, base64: null }} />}
  />
);
